import CallCenterNav from "../../pages/Dashboard/CallCenter/CallCenterNav";
import CallCenterIndex from "../../pages/Dashboard/CallCenter/CallCenterIndex";
import AddClient from "../../pages/Dashboard/CallCenter/Clients/AddClient";
import ClientList from "../../pages/Dashboard/CallCenter/Clients/ClientList";
import TransferClients from "../../pages/Dashboard/CallCenter/TransferClients/TransferClients";
import Employees from "../../pages/Dashboard/CallCenter/Clients/Employees";
import PatientList from "../../pages/Dashboard/CallCenter/patients/PatientList";
import HtPatientView from "../../pages/Dashboard/CallCenter/patients/HtPatientView";
import BeautyPatientView from "../../pages/Dashboard/CallCenter/patients/BeautyPatientView";
import DentalPatientView from "../../pages/Dashboard/CallCenter/patients/DentalPatientView";
import Dashboard from "../../pages/Dashboard/CallCenter/patients/Dashboard";
import ViewClientNav from "../../pages/Dashboard/CallCenter/Clients/ViewClientNav";
import OpdClients from "../../pages/Dashboard/CallCenter/Clients/OpdClients";
import SuccessClients from "../../pages/Dashboard/CallCenter/Clients/SuccessClients";
import Search from "../../pages/Dashboard/CallCenter/Search";
import InProgress from "../../pages/Dashboard/CallCenter/InProgress";
import FollowUps from "../../pages/Dashboard/CallCenter/FollowUps";
import AllClients from "../../pages/Dashboard/CallCenter/Clients/AllClients";

const CallCenterRoutes = {
  path: "/call-center",
  element: <CallCenterNav />,
  children: [
    { path: "/call-center", element: <CallCenterIndex /> },
    { path: "/call-center/add-client", element: <AddClient /> },
    { path: "/call-center/search", element: <Search /> },
    { path: "/call-center/in-progress", element: <InProgress /> },
    { path: "/call-center/follow_ups", element: <FollowUps /> },
    {
      path: "/call-center/view-client",
      element: <ViewClientNav />,
      children: [
        { path: "", element: <ClientList /> },
        {
          path: "call-center/view-clients",
          element: <ClientList />,
        },

        {
          path: "call-center/opd-clients",
          element: <OpdClients />,
        },
        {
          path: "call-center/success-clients",
          element: <SuccessClients />,
        },

        {
          path: "call-center/all-clients",
          element: <AllClients />,
        },
      ],
    },
    {
      path: "/call-center/view-procedure",
      element: <PatientList />,
      children: [
        { path: "", element: <Dashboard /> },
        { path: "call-center/dashboard", element: <Dashboard /> },
        { path: "call-center/ht-patient-view", element: <HtPatientView /> },
        {
          path: "call-center/beauty-patient-view",
          element: <BeautyPatientView />,
        },
        {
          path: "call-center/dental-patient-view",
          element: <DentalPatientView />,
        },
      ],
    },
    { path: "/call-center/transfer-clients", element: <TransferClients /> },
    { path: "/call-center/employees", element: <Employees /> },
  ],
};

export default CallCenterRoutes;
